import { Component,
         Output,
         EventEmitter, 
         AfterViewInit}               from '@angular/core';
import { TableColumn,
         TableColumnType }            from '../common/table-column';
import { TrainService }               from '../shared/train.service';
import { HolidayExceptionService }                from '../shared/holiday-exception.service';
import { Observable }                 from 'rxjs/Observable';
import { ISortableFilter,
         SortableFilter }             from '../common/sortable-filter';
import { HolidayExceptionSortableFilter }         from './holiday-exception-filter';
import { HolidayExceptionDialogComponent }        from '../holiday-exception-dialog/holiday-exception-dialog.component';
import { MatDialog, MatSnackBar }                   from '@angular/material';
import { Globals }                    from '../common/globals';
import { SavingDialogComponent }      from '../common/saving-dialog.component';
import { LoadingDialogComponent } from '../common/loading-dialog.component';
import { HolidayExceptionItemModel } from './holiday-exception-item.model';
import { toNetParameterDate } from '../common/functions';


@Component({
  selector: 'sa-holiday-exception-list',
  template: require('./holiday-exception-list.component.html'),
  styles: [require('./holiday-exception-list.component.scss')]
})
export class HolidayExceptionListComponent implements AfterViewInit {

  @Output() filter = new HolidayExceptionSortableFilter('ExceptionDate');
  @Output() performSearch = new EventEmitter();
  @Output() columns: Array<TableColumn>;
  @Output() service: HolidayExceptionService;

  public getDataCallback: Function;
  trainFilter: ISortableFilter = new SortableFilter('trainName');
  exceptionDateFilter: ISortableFilter = new SortableFilter('exceptionDate');

  public trains: any[];
  public trainsReady = false;
  public filterReady = false;

  constructor(
    trainService: TrainService,
    holidayService: HolidayExceptionService,
    public dialog: MatDialog,
    public globals: Globals,
    private snackbar: MatSnackBar
  ) {
     this.getDataCallback = this.getData.bind(this);
     this.service = holidayService;

    let cloakRef = this.dialog.open(LoadingDialogComponent);
    trainService.getNames(this.trainFilter)
      .subscribe(t => {
        this.trains = t;
        this.trainsReady = true;
        cloakRef.close();
      });

      this.columns = [
        new TableColumn(TableColumnType.Text, 'trainName', 'Spoj', 70),
        new TableColumn(TableColumnType.Date, 'exceptionDate', 'Datum', 100),
        new TableColumn(TableColumnType.Number, 'dayOfWeekSource', 'Jako den v týdnu', 100, false, null, false, (val) => {
          if (val === 1) { return  'Pondělí'; }
          if (val === 2) { return  'Úterý'; }
          if (val === 3) { return  'Středa'; }
          if (val === 4) { return  'Čtvrtek'; }
          if (val === 5) { return  'Pátek'; }
          if (val === 6) { return  'Sobota'; }
          if (val === 7) { return  'Neděle'; }
        }),
        new TableColumn(TableColumnType.Number, 'orderCoef', 'Koeficient', 100),
        new TableColumn(TableColumnType.Text, 'trainDescription', 'Popis spoje', 250)
      ];
  }

  ngAfterViewInit(): void {
    this.filterChanged(null);
  }

  private getData(filter: HolidayExceptionSortableFilter) {
    // if (!!filter.trainUid) {

    if (!!filter.exceptionDateObj) {
      filter.exceptionDate = toNetParameterDate(filter.exceptionDateObj);
    } else {
      filter.exceptionDate = null;
    }

    return this.service.getItems(filter);
    // }
    // return Observable.from(Array<any>());
  }

  private filterChanged(event) {
      this.filterReady = true;
      this.performSearch.emit(this.filter);
  }

  public addNew() {
    let dialogRef = this.dialog.open(HolidayExceptionDialogComponent);
    dialogRef.componentInstance.model = new HolidayExceptionItemModel();
    dialogRef.componentInstance.newItem = true;
    let snack = this.snackbar;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.service.insertItem(dialogRef.componentInstance.model)
        .subscribe(
            res => {
                cloakRef.close();
                this.filterChanged(null);
                snack.open('Úspěšně uloženo.', '', {duration: 2000});
            },
            error => {
                snack.open(error.message, 'Zavřít');
            });
      }
    });
  }


  editItem(model) {
    let dialogRef = this.dialog.open(HolidayExceptionDialogComponent);
    dialogRef.componentInstance.model = model;
    let train = this.trains.filter((t, i) => t.trainUid === model.trainUID)[0];
    dialogRef.componentInstance.model.trainName = train.trainName;
    let snack = this.snackbar;
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        this.service.updateItem(dialogRef.componentInstance.model.orderHolidayExceptionID + '', dialogRef.componentInstance.model)
          .subscribe(res => {
            console.log('HolidayException updated');
            this.performSearch.emit(this.filter);
          },
          error => {
            snack.open(error.message, 'Zavřít');
          });
      } else if (result === 'delete') {
        this.service.deleteItem(dialogRef.componentInstance.model.orderHolidayExceptionID + '')
          .subscribe(res => {
            console.log('HolidayException updated');
            this.performSearch.emit(this.filter);
          }, _ => {
            snack.open('Při mazání se vyskytla chyba.', 'Zavřít');
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/holiday-exception-list/holiday-exception-list.component.ts